(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[287],{

/***/ 95002:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/hunnys",
      function () {
        return __webpack_require__(37843);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ hunnys; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/primitives/index.ts + 13 modules
var primitives = __webpack_require__(21666);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(51943);
;// CONCATENATED MODULE: ./public/HunnysHalfBanner.png
/* harmony default export */ var HunnysHalfBanner = ({"src":"/_next/static/media/HunnysHalfBanner.e63a5903.png","height":502,"width":3456,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAAGFBMVEVAtnzfO0/oeR3HVHyHbrHMPbZSxJK1wlKoYea+AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEUlEQVR4nGNgYGFlZGJnYwYAAHQAHYG/gtYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./public/hunnysCollectionGif.gif
/* harmony default export */ var hunnysCollectionGif = ({"src":"/_next/static/media/hunnysCollectionGif.f96278a1.gif","height":700,"width":700});
// EXTERNAL MODULE: ./stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(50530);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(80672);
// EXTERNAL MODULE: ./components/home/Footer.tsx
var Footer = __webpack_require__(53593);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./hooks/index.ts + 7 modules
var hooks = __webpack_require__(82731);
// EXTERNAL MODULE: ./components/Card.tsx
var Card = __webpack_require__(16050);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Head.tsx
var Head = __webpack_require__(4049);
// EXTERNAL MODULE: ./context/ChainContextProvider.tsx
var ChainContextProvider = __webpack_require__(43810);
;// CONCATENATED MODULE: ./pages/about/hunnys.tsx


















const List = (0,stitches_config/* styled */.zo)("ul", {
    paddingLeft: "1em",
    "& li": {
        position: "relative",
        "&::before": {
            content: '""',
            position: "absolute",
            left: "-1em",
            top: "0.5em",
            width: "0.75em",
            height: "0.75em",
            background: 'url("/hunnysHeart.svg") no-repeat',
            backgroundSize: "contain"
        }
    }
});
const AboutBlock = (0,stitches_config/* styled */.zo)("div", {
    color: "white",
    border: "3px solid #F4CC45",
    backgroundColor: "#5A1CDA",
    borderRadius: "5px",
    padding: "10px",
    marginBottom: "10px",
    "&:hover": {
        color: "white",
        backgroundColor: "#9362F6"
    },
    "@dark": {
        backgroundColor: "$hunnysDarkPurple"
    }
});
const HunnysPage = (param)=>{
    let { ssr  } = param;
    const isSSR = "object" === "undefined";
    const isMounted = (0,hooks/* useMounted */.s4)();
    const compactToggleNames = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 800px)"
    });
    const [sortByTime, setSortByTime] = (0,react.useState)("1DayVolume");
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { isDisconnected  } = (0,dist/* useAccount */.mA)();
    const card1Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/a31f62eb044029c6c2f534a5a4ba4d9a.png",
        "https://dl.openseauserdata.com/cache/originImage/files/d92f3b38a8ceef123fd18fa4548d4517.png",
        "https://dl.openseauserdata.com/cache/originImage/files/99a9cdce6c45fbfdb6f95c93cae1d6ef.png",
        "https://dl.openseauserdata.com/cache/originImage/files/3f44fe1f936f81f431dc6f730447f199.png"
    ];
    const card2Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/a2a614ec8423da2a8c633e87ed7ce020.png",
        "https://dl.openseauserdata.com/cache/originImage/files/30f26e28f4632846e9bf24c4b825ab1a.png",
        "https://dl.openseauserdata.com/cache/originImage/files/6821fa106cc8e018123a92467ed41405.png",
        "https://dl.openseauserdata.com/cache/originImage/files/d2fd15cea3e6b087313b9f339dff0402.png",
        "https://dl.openseauserdata.com/cache/originImage/files/a60cd48181eaa7bb69e19ad771c13193.png"
    ];
    const card3Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/c0cd9148326df1c11fbadbfd3c366748.png",
        "https://dl.openseauserdata.com/cache/originImage/files/7427952a6e10ce6780dab1af7ccb85d0.png",
        "https://dl.openseauserdata.com/cache/originImage/files/d614ec60c986995f8a7e3b93860900e6.png",
        "https://dl.openseauserdata.com/cache/originImage/files/ff0e96fa3b1843c2daa3a4c2cc6f946c.png"
    ];
    const card4Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/5fdbd27bbd320a6d9025f2a5d85ae846.png",
        "https://dl.openseauserdata.com/cache/originImage/files/f8deafd3946cfa289e5369ec92018ff7.png",
        "https://dl.openseauserdata.com/cache/originImage/files/ffe9faef0676afb6cdcec96bd45c60e2.png",
        "https://dl.openseauserdata.com/cache/originImage/files/2670f86e2c141b1e988f110cb0a1a16c.png"
    ];
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    let volumeKey = "allTime";
    switch(sortByTime){
        case "1DayVolume":
            volumeKey = "1day";
            break;
        case "7DayVolume":
            volumeKey = "7day";
            break;
        case "30DayVolume":
            volumeKey = "30day";
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "Hunnys Banner",
                src: HunnysHalfBanner,
                style: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                css: {
                    background: "$hunnysPurple",
                    p: 24,
                    height: "100%",
                    position: "relative",
                    "@bp800": {
                        p: "$6"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        align: "center",
                        css: {
                            mx: "auto",
                            maxWidth: 728,
                            pt: "$5",
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "4rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "Hunnys"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "Hunnys Gif",
                                src: hunnysCollectionGif,
                                width: 200,
                                style: {
                                    borderRadius: 50
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    alignSelf: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        css: {
                                            minWidth: 224,
                                            marginTop: 50,
                                            justifyContent: "center",
                                            fontFamily: "Luckiest Guy, cursive",
                                            background: "$btn2",
                                            color: "#5A1CDA",
                                            "&:hover": {
                                                backgroundColor: "#F4CC45"
                                            },
                                            fontSize: "1.5rem",
                                            fontWeight: 100,
                                            letterSpacing: "1px",
                                            textTransform: "uppercase"
                                        },
                                        size: "large",
                                        children: "Shop Hunnys"
                                    })
                                })
                            })
                        ]
                    }),
                    isDisconnected && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        align: "center",
                        css: {
                            mx: "auto",
                            maxWidth: 728,
                            pt: "$5",
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body1",
                                css: {
                                    mb: 48
                                },
                                children: "Connect your wallet to begin shopping, or to explore what you already own!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* ConnectWalletButton */.p, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            my: "$6",
                            gap: 65
                        },
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "3rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "About"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "start",
                                css: {
                                    flexDirection: "column",
                                    marginRight: "auto",
                                    gap: "10%",
                                    "@bp1400": {
                                        alignItems: "left",
                                        flexDirection: "row",
                                        margin: 12
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                                        css: {
                                            textAlign: "left",
                                            fontSize: 24,
                                            marginBottom: 30
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    "Collect clothes, dyes and pets to customize your Hunny ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            fontSize: 12
                                                        },
                                                        children: "(Coming Soon)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Revolutionary color harmony algorithm"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Over 1 million unique combinations"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "9 unique trait categories & rarity system"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Free art airdrops every month"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Blockchain-based merch shop"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "One of the earliest known NFTs created by a woman that represent women"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        width: "448px",
                                        height: "252px",
                                        src: "https://www.youtube.com/embed/HM7iJteTURA",
                                        title: "YouTube video player",
                                        frameBorder: "0",
                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "3rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "Benefits"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                                css: {
                                    textAlign: "left",
                                    fontSize: 24,
                                    marginBottom: 30
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Monthly Art Airdrops"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Access to minting in the Hupe Scouts collection"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Exclusive Merchandise"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Creative Licensing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "And more!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "3rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "Stats"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                                css: {
                                    textAlign: "left",
                                    fontSize: 24,
                                    marginBottom: 30
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Launched in Sept. 2021"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Ξ700 traded"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Over 1 million unique combinations"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "9 unique trait categories & rarity system"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Free art airdrops every month"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Blockchain-based merch shop"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "One of the earliest known NFTs "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "3rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "What suits you?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "center",
                                align: "stretch",
                                css: {
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    gap: 24,
                                    "@bp1100": {
                                        justifyContent: "space-between"
                                    },
                                    "@bp800": {
                                        justifyContent: "space-between"
                                    },
                                    "@bp500": {
                                        justifyContent: "center"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Cheer Squad",
                                        carouselImages: card1Images,
                                        button2Link: "/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded?attributes%5BOutfit%5D=BunnyUCheerTop",
                                        button2Text: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Friendly Pet Crew",
                                        carouselImages: card2Images,
                                        button2Link: "/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded?attributes%5BHat%5D=CuteBird&attributes%5BHat%5D=BabyBunny&attributes%5BHat%5D=GhostKittyFriend&attributes%5BHat%5D=GhostCrocFriend&attributes%5BHat%5D=BooTheGhostFloop&attributes%5BHat%5D=HappyJohnathanTheFrog&attributes%5BHat%5D=BabyDragon&attributes%5BHat%5D=CuteOctopusHat",
                                        button2Text: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Bikini Babes",
                                        carouselImages: card3Images,
                                        button2Link: "/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded?attributes%5BOutfit%5D=StripedBikini",
                                        button2Text: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Horny Hunnys",
                                        carouselImages: card4Images,
                                        button2Link: "/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded?attributes%5BHat%5D=DevilHorns&attributes%5BHat%5D=DemonHorns",
                                        button2Text: "SHOP"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "3rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "More Information"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                async: true,
                                src: "https://platform.twitter.com/widgets.js",
                                charSet: "utf-8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "center",
                                align: "center",
                                css: {
                                    flexDirection: "column",
                                    marginRight: "auto",
                                    gap: 12,
                                    "@bp1000": {
                                        alignItems: "center",
                                        flexDirection: "row",
                                        margin: 12
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                        css: {
                                            width: "calc(33.3%)",
                                            margin: "20px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: '          <blockquote class="twitter-tweet">              <p lang="en" dir="ltr">❤️ What is Hunnys? ❤️<br><br>Unleash your creativity with Hunnys - the revolutionary digital doll on the Ethereum blockchain.<br><br>Collect unique items, customize with over 1 million combinations, &amp; explore The Bunny Kingdom\uD83D\uDC30\uD83D\uDC8E<br><br>\uD83E\uDDF5\uD83D\uDC47 <a href="https://t.co/YSHwNAv4ll">pic.twitter.com/YSHwNAv4ll</a></p>\n                  &mdash; Hunnys \uD83D\uDC9B (@HunnysNFT) <a href="https://twitter.com/HunnysNFT/status/1621628406990356481?ref_src=twsrc%5Etfw">February 3, 2023</a>\n                </blockquote>\n              '
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                        css: {
                                            width: "calc(33.3%)",
                                            margin: "20px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: '          <blockquote class="twitter-tweet"><p lang="en" dir="ltr">On Aug. 23, we officially opened Bunny University ✏️<br><br>We wanted to give you some very quick context into...<br><br>\uD83D\uDCD3What our first class was like<br>\uD83D\uDCD3Why we started it<br>\uD83D\uDCD3Where Bunny University is headed<br><br>Please turn the page \uD83D\uDC47 <a href="https://t.co/g6xH8o34TP">pic.twitter.com/g6xH8o34TP</a></p>&mdash; Hunnys \uD83D\uDC9B (@HunnysNFT) <a href="https://twitter.com/HunnysNFT/status/1562500554567618561?ref_src=twsrc%5Etfw">August 24, 2022</a></blockquote>\n                </blockquote>\n              '
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                        css: {
                                            width: "calc(33.3%)",
                                            margin: "20px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: '<blockquote class="twitter-tweet"><p lang="en" dir="ltr">⭐️Introducing... HUPE SCOUTS!⭐️<br><br>The Official Community-Owned Hunnys Derivative Brand!<br><br>Please take a look with us through this brand new initiative that the Hunnys team is launching today. We&#39;ll first introduce it, then include all need-to-know links &amp; info at the end\uD83D\uDC96 <a href="https://t.co/KzHPclNrJ1">pic.twitter.com/KzHPclNrJ1</a></p>&mdash; Hunnys \uD83D\uDC9B (@HunnysNFT) <a href="https://twitter.com/HunnysNFT/status/1545468213085052929?ref_src=twsrc%5Etfw">July 8, 2022</a></blockquote>\n              '
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    alignSelf: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        css: {
                                            minWidth: 224,
                                            marginTop: 50,
                                            justifyContent: "center",
                                            fontFamily: "Luckiest Guy, cursive",
                                            background: "$btn2",
                                            color: "#5A1CDA",
                                            "&:hover": {
                                                backgroundColor: "#F4CC45"
                                            },
                                            fontSize: "1.5rem",
                                            fontWeight: 100,
                                            letterSpacing: "1px",
                                            textTransform: "uppercase"
                                        },
                                        size: "large",
                                        children: "Shop Hunnys"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var hunnys = (HunnysPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,5864,5535,1943,6485,9774,2888,179], function() { return __webpack_exec__(95002); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);